import React from 'react';
import Home from './Home.jsx';
import PartnerWithUs from './PartnerWithUs.jsx';
import { LANDING_PAGE_CONFIG, LANDING_PAGES } from '../config/landing.config.jsx';

/**
 * Configurable Landing Page Component
 * Renders different landing pages based on LANDING_PAGE_CONFIG
 * 
 * To switch landing pages, update LANDING_PAGE_CONFIG in src/config/landing.config.jsx
 */
const Landing = () => {
  const renderLandingPage = () => {
    switch (LANDING_PAGE_CONFIG) {
      case 1:
        return <Home />;
      case 2:
        return <PartnerWithUs />;
      // Future: case 3: return <ThirdLandingPage />;
      default:
        // Fallback to Home if config is invalid
        console.warn(`Invalid LANDING_PAGE_CONFIG: ${LANDING_PAGE_CONFIG}. Defaulting to Home.`);
        return <Home />;
    }
  };

  return renderLandingPage();
};

export default Landing;

